import React from "react";
import img from "../images/Error-img.webp"
 const EmptyPage=()=>{

    return(
        <div>
       <img  style={{width:"90%",height:"650px",margin:"0 auto"}}src={img}></img>

        </div>
    )

 }
 export default EmptyPage;